import { ExternalConnection } from '@griply/types';

import { canConnectionReadContacts } from './can-connection-read-contacts';
import { isConnectionBroken } from './is-connection-broken';

// A broken connection is excluded: it needs a plain reconnect, not a contacts-scope upgrade.
export const connectionNeedsContactsReconnect = (
  connection: ExternalConnection,
): boolean =>
  !isConnectionBroken(connection) && !canConnectionReadContacts(connection);
